import type { ComponentPropsWithRef, ReactElement } from 'react';
import { cn } from '../util/classes.ts';

export type InputProps = ComponentPropsWithRef<'input'>;

export const inputStyles = cn(
    'min-h-interactive px-cozy w-full',
    'inline-flex cursor-text items-center gap-cozy text-content',
    'rounded-tight border border-line-weak outline-none',
    'transition duration-state ease-state',
    'placeholder:text-content-weaker',
    // fix spinner for number input (chrome only)
    '[&::-webkit-inner-spin-button]:-my-2',
    // states
    'hover:border-line-strong',
    'focus:border-brand focus:ring-0 focus:hover:border-brand',
    'state-invalid:text-danger state-invalid:border-danger state-invalid:hover:border-danger state-invalid:focus:border-danger',
    'state-disabled:pointer-events-none state-disabled:border-line-weak state-disabled:bg-container-disabled',
    'state-disabled:text-content-disabled state-disabled:placeholder:text-transparent',
);

export function Input({ className, ...props }: InputProps): ReactElement {
    return <input data-slot="input" className={cn(inputStyles, className)} {...props} />;
}
